import { Gradient } from './Gradient';

const RainbowGradient = new Gradient(
  "rgb(0,72,255)", 
  "rgb(0,151,255)", 
  "rgb(16,222,234)", 
  "rgb(70,255,184)", 
  "rgb(149,255,90)", 
  "rgb(223,237,23)", 
  "rgb(255,170,0)", 
  "rgb(255,60,0)", 
  "rgb(255,0,0)"  
);

export { RainbowGradient }
